import { Route, Routes } from "react-router-dom";
import AdminModule from ".";

const AdminRoute = () => {
  return (
    <Routes>
      <Route path="/:view/:userId?" element={<AdminModule />} />
      <Route path="/*" element={<AdminModule />} />
    </Routes>
  );
};

export default AdminRoute;
